import Http from '@/utils/request'

import type {
  DistributeListRes,
  DistributeTabRes,
  RadioSimpleCreateRes,
  UserCartoonRes,
  UserInfoRes,
  UserWorkRes,
} from './type'

/**
 * 获取分发列表
 */
export function distributeList(): Promise<DistributeListRes> {
  return Http({
    url: '/distribute/list',
    method: 'get',
  })
}

/**
 * 获取分发 tab/pipe 列表
 * @param tabId tab id
 * @param pageNo 页码（最小 1）
 */
export function distributeTab(id: string, pageNo: number): Promise<DistributeTabRes> {
  return Http({
    url: `/distribute/tab/${id}`,
    method: 'get',
    params: {
      pageNo: pageNo >= 1 ? pageNo : 1,
    },
  })
}

/**
 * 用户作品
 * @param userId 用户id
 * @param obj 作品类型[全部：all，互动内容：pipe，听听：radio，novel：小说，media：视频图文]
 * @param secPageNo 将接口返回的值原样返回即可
 * @param pageNo 页码
 * @returns
 */
export function userWork(
  userId: string,
  obj: string,
  secPageNo: number,
  pageNo: number,
): Promise<UserWorkRes> {
  return Http({
    url: `/user/work/${userId}`,
    method: 'get',
    params: {
      obj,
      secPageNo,
      pageNo,
    },
  })
}

/**
 * 用户主页头部信息
 * @param uid 用户短 id 或服务端可识别的用户标识
 */
export function userInfo(uid: string): Promise<UserInfoRes> {
  return Http({
    url: `/user/info/${uid}`,
    method: 'get',
  })
}

/**
 * 用户主页角色列表
 * @param uid 用户短 id 或服务端可识别的用户标识
 * @param pageNo 页码
 */
export function userCartoon(uid: string, pageNo: number): Promise<UserCartoonRes> {
  return Http({
    url: '/user/cartoon',
    method: 'get',
    params: {
      uid,
      pageNo: pageNo >= 1 ? pageNo : 1,
    },
  })
}

/**
 * 我的草稿作品
 * @param obj 作品类型[全部：all，互动内容：pipe，听听：radio，novel：小说，media：视频图文]
 * @param secPageNo 将接口返回的值原样返回即可
 * @param pageNo 页码
 * @returns
 */
export function userWorkDraft(
  obj?: string,
  secPageNo?: number,
  pageNo?: number,
): Promise<UserWorkRes> {
  return Http({
    url: '/user/work/draft',
    method: 'get',
    params: {
      ...(obj !== undefined && { obj }),
      ...(secPageNo !== undefined && { secPageNo }),
      ...(pageNo !== undefined && { pageNo }),
    },
  })
}

/**
 * 听听编辑页-快速创建听听草稿（返回id）
 */
export function radioSimpleCreate(): Promise<RadioSimpleCreateRes> {
  return Http({
    url: '/radio/simple/create',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}
